// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 768px) {
  #toolbar {
    flex-direction: column;
  }
  
  .save-button {
    margin-left: 0;
    margin-top: 8px;
    width: 100%;
  }
  
  .save-button button {
    width: 100%;
  }
}

.save-button{
  color: #000 !important;
  background-color: transparent !important; 
  border-color: #dee2e6 !important;
  transition: all 0.2s ease;
}

.save-button:hover{
  color: #0a38cf !important; 
  background-color: transparent !important;
  border-color: #343a40 !important; 
}

.save-button:focus, 
.save-button:active {
  box-shadow: none !important;
  outline: none !important;
  background-color: transparent !important;
  color: #000 !important;
}

.save-button:disabled {
  opacity: 0.6;
  color: #000 !important;
  background-color: transparent !important;
}

.sticky-toolbar {
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #fff;
  margin-bottom: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}


.ql-container.ql-snow {
  border: none;
}


.challenge-wrapper {
  margin: 30px 0;
}

.challenge-container {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  border: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.challenge-container:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.lightbulb-icon {
  color: #ffeb3b;
  font-size: 1.2rem;
}


.challenge-feedback {
  border-radius: 8px;
  padding: 10px 15px;
}

.challenge-feedback.success {
  background-color: #d1e7dd;
  color: #0f5132;
  border-color: #badbcc;
}

.challenge-feedback.error {
  background-color: #f8d7da;
  color: #842029;
  border-color: #f5c2c7;
}

.challenge-description {
  font-style: italic;
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 20px;
}

.challenge-question {
  font-size: 1.6rem !important; 
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  line-height: 1.4;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(106, 17, 203, 0.2);
}

.challenge-option {
  padding: 12px 18px;
  border-radius: 10px;
  background-color: #f8f9fa;
  margin-bottom: 12px;
  transition: all 0.2s ease;
  cursor: pointer; 
}

.challenge-option:hover {
  background-color: #e9ecef;
  transform: translateX(5px);
}


.challenge-option.selected {
  background-color: rgba(106, 17, 203, 0.1);
  border-left: 4px solid #6a11cb;
}


.challenge-validate {
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  border: none;
  padding: 12px 24px;
  border-radius: 50px;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 10px rgba(37, 117, 252, 0.3);
  transition: all 0.3s ease;
  margin-top: 15px;
}

.challenge-validate:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 15px rgba(37, 117, 252, 0.4);
}

.download-pdf-btn {
  transition: all 0.3s ease;
  border-color: #007bff;
  color: #007bff;
}

.download-pdf-btn:hover {
  background-color: #007bff;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);
}

.view-pdf-btn {
  transition: all 0.3s ease;
  border-color: #6c757d;
  color: #6c757d;
}

.view-pdf-btn:hover {
  background-color: #6c757d;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(108, 117, 125, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/Components/TheoryLesson/TheoryLesson.css"],"names":[],"mappings":"AAAA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;;EAEE,2BAA2B;EAC3B,wBAAwB;EACxB,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;AAC3C;;;AAGA;EACE,YAAY;AACd;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;;AAGA;EACE,yCAAyC;EACzC,8BAA8B;AAChC;;;AAGA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,8CAA8C;EAC9C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,2BAA2B;EAC3B,8CAA8C;AAChD","sourcesContent":["@media (max-width: 768px) {\n  #toolbar {\n    flex-direction: column;\n  }\n  \n  .save-button {\n    margin-left: 0;\n    margin-top: 8px;\n    width: 100%;\n  }\n  \n  .save-button button {\n    width: 100%;\n  }\n}\n\n.save-button{\n  color: #000 !important;\n  background-color: transparent !important; \n  border-color: #dee2e6 !important;\n  transition: all 0.2s ease;\n}\n\n.save-button:hover{\n  color: #0a38cf !important; \n  background-color: transparent !important;\n  border-color: #343a40 !important; \n}\n\n.save-button:focus, \n.save-button:active {\n  box-shadow: none !important;\n  outline: none !important;\n  background-color: transparent !important;\n  color: #000 !important;\n}\n\n.save-button:disabled {\n  opacity: 0.6;\n  color: #000 !important;\n  background-color: transparent !important;\n}\n\n.sticky-toolbar {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  background-color: #fff;\n  margin-bottom: 10px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n\n.ql-container.ql-snow {\n  border: none;\n}\n\n\n.challenge-wrapper {\n  margin: 30px 0;\n}\n\n.challenge-container {\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  border: none;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.challenge-container:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n.lightbulb-icon {\n  color: #ffeb3b;\n  font-size: 1.2rem;\n}\n\n\n.challenge-feedback {\n  border-radius: 8px;\n  padding: 10px 15px;\n}\n\n.challenge-feedback.success {\n  background-color: #d1e7dd;\n  color: #0f5132;\n  border-color: #badbcc;\n}\n\n.challenge-feedback.error {\n  background-color: #f8d7da;\n  color: #842029;\n  border-color: #f5c2c7;\n}\n\n.challenge-description {\n  font-style: italic;\n  color: #6c757d;\n  font-size: 0.9rem;\n  margin-bottom: 20px;\n}\n\n.challenge-question {\n  font-size: 1.6rem !important; \n  font-weight: 600;\n  color: #333;\n  margin-bottom: 20px;\n  line-height: 1.4;\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(106, 17, 203, 0.2);\n}\n\n.challenge-option {\n  padding: 12px 18px;\n  border-radius: 10px;\n  background-color: #f8f9fa;\n  margin-bottom: 12px;\n  transition: all 0.2s ease;\n  cursor: pointer; \n}\n\n.challenge-option:hover {\n  background-color: #e9ecef;\n  transform: translateX(5px);\n}\n\n\n.challenge-option.selected {\n  background-color: rgba(106, 17, 203, 0.1);\n  border-left: 4px solid #6a11cb;\n}\n\n\n.challenge-validate {\n  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);\n  border: none;\n  padding: 12px 24px;\n  border-radius: 50px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  box-shadow: 0 4px 10px rgba(37, 117, 252, 0.3);\n  transition: all 0.3s ease;\n  margin-top: 15px;\n}\n\n.challenge-validate:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 15px rgba(37, 117, 252, 0.4);\n}\n\n.download-pdf-btn {\n  transition: all 0.3s ease;\n  border-color: #007bff;\n  color: #007bff;\n}\n\n.download-pdf-btn:hover {\n  background-color: #007bff;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.2);\n}\n\n.view-pdf-btn {\n  transition: all 0.3s ease;\n  border-color: #6c757d;\n  color: #6c757d;\n}\n\n.view-pdf-btn:hover {\n  background-color: #6c757d;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(108, 117, 125, 0.2);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
